<div class="details-container__loading" *ngIf="isLoading">
  <sc-icon icon="loading" size="2"></sc-icon>
</div>
<div class="details-container" *ngIf="data && !isLoading">
  <div class="details-container__date">Notificación {{ data.receivedDate | date:'dd/MM/yy' }}</div>
  <h2 class="details-container__title">Cancelación de póliza</h2>
  <div class="details-container__box">
    <div class="row">
      <div class="col-lg-3 col-md-12 details-container__box__group">
        <p>N° {{ data.policyNumber || data.jobNumber }}</p>
        <p>{{ data.insuredName | titlecase }}</p>
      </div>
      <div class="col-lg-3 col-md-12 details-container__box__group">
        <p>{{ data.branch | scBranchDescription | titlecase }}</p>
        <p>{{ data.risk | scDynamoRiskCleanup }}</p>
      </div>
    </div>
    <div class="row details-container__box">
      <div class="col-md-12">
        <h3>Motivo</h3>
      </div>
      <div class="col-md-12">{{ data.data.CancellationReason }}</div>
    </div>
    <div class="row details-container__box" *ngIf="data.data.CancellationComment">
      <div class="col-md-12">
        <h3>Comentarios</h3>
      </div>
      <div class="col-md-12">{{ data.data.CancellationComment }}</div>
    </div>
  </div>
</div>